/**
 * Cocktail Book DataLayer Tracking
 * Tracks filter_interaction events
 */

(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  // Get filter label text from DOM (already translated)
  function getFilterLabel(checkbox) {
    const label = checkbox.closest('label');
    if (label) {
      const span = label.querySelector('span');
      if (span) {
        return span.textContent.trim();
      }
    }
    // Fallback: return checkbox value if label not found
    return checkbox.value;
  }

  function getSelectedFilters() {
    const filters = {
      product: null,
      flavour: null,
      occasion: null,
      category: null
    };

    ['product', 'flavour', 'occasion', 'category'].forEach((filterName) => {
      const checked = document.querySelectorAll(`input[name="${filterName}"]:checked`);
      if (checked.length > 0) {
        const values = Array.from(checked).map((checkbox) => {
          return getFilterLabel(checkbox);
        });
        filters[filterName] = values.join(', ');
      }
    });

    return filters;
  }

  function trackFilterInteraction() {
    const selected = getSelectedFilters();
    
    window.dataLayer.push({
      'event': 'filter_interaction',
      'filter_product': selected.product || '',
      'filter_flavor': selected.flavour || '',
      'filter_occasion': selected.occasion || '',
      'filter_category': selected.category || ''
    });
  }

  // Listen for filter checkbox changes
  const filterCheckboxes = document.querySelectorAll('.filters input[type="checkbox"]');
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      trackFilterInteraction();
    });
  });

})();
